// import React, { useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import Spinner from "../app/shared/Spinner";



// const RoleRedirect = () => {
//     const admin = JSON.parse(localStorage.getItem("admin"));
//     const navigate = useNavigate();
   
//     const location = useLocation(); // Get location from React Router

//     console.log('admin role in role redirect=============', admin);
    
//     useEffect(() => {
//       if(admin?.role === "earnings-report-only"){
//         // navigate("/totalReport");


//           // Redirect to totalReport if trying to access dashboard
//       if (location.pathname === "/dashboard") {
//         navigate("/totalReport", { replace: true });
//       }
//       // Or if coming from login, go directly to totalReport
//       else if (location.pathname === "/" || location.pathname === "/login") {
//         navigate("/totalReport", { replace: true });
//       }
//       }else if (admin?.role === "ticket-admin") {
//         navigate("/tickets-dashboard");
//       } else if (admin?.role === "tracking-admin") {
//         navigate("/tracking-dashboard");
//       }
//       else if (admin) {
//         navigate("/dashboard");
//       } else {
//         navigate("/login"); // or your login route
//       }
//     }, [admin, navigate]);
  
//     return <Spinner />; // Show loading while redirecting
//   };

//   export default RoleRedirect;




import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Spinner from "../app/shared/Spinner";

const RoleRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    const at = location.pathname;

    if (!admin) {
      if (at !== "/login") navigate("/login", { replace: true });
      return;
    }

    const role = admin.role;

    console.log('Admin role in RoleRedirect:', role);

    if (role === "earnings-report-only" && at !== "/totalReport") {
      navigate("/totalReport", { replace: true });
      return;
    }

    if (role === "ticket-admin" && at !== "/tickets-dashboard") {
      navigate("/tickets-dashboard", { replace: true });
      return;
    }

    if (role === "tracking-admin" && at !== "/tracking-dashboard") {
      navigate("/tracking-dashboard", { replace: true });
      return;
    }

    if ((at === "/" || at === "/login") && role) {
      navigate("/dashboard", { replace: true });
    }
  }, [location.pathname, navigate]);

  return <Spinner />;
};

export default RoleRedirect;
